import React, { useState, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import FormHandler from "../../Common/Form/FormHandler/FormHandler";
import "./UserTaskManagement.css";
import { useKeycloak } from "@react-keycloak/web";
import { toast, ToastContainer } from "react-toastify";
import {
  TaskMgntFormConfig,
  usertaskmgntschema
} from "../../../../JsonData/CreateTaskMgntConfig";
import {
  postDataWithBody,
  getData,
  putDataWithBody,
  postDataWithBodyFrGIS,
} from "../../../../Services/Services";
import {
  getUsersFromApp,
  getAllRole,
  createTaskandAssign,
  createNewTask
} from "../../../../Services/EndPoints";
import { yupResolver } from "@hookform/resolvers/yup";
 
const CreateUserTaskForm = () => {
  const { keycloak } = useKeycloak();
  const [activeTab, setActiveTab] = useState(0);
  const [loader, setLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [taskMgntFormConfig, setTaskMgntFormConfig] = useState(
    TaskMgntFormConfig
  );
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  let data = state?.data;
 
  const [lgShow, setLgShow] = useState(false);
 
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(usertaskmgntschema[activeTab]),
    mode: "all",
  });
 
  const assign_type = useWatch({
    name: "assign_type",
    control,
  });
 
  const task_type = useWatch({
    name: "task_type",
    control,
  });
 
  // Initial setup on component mount
  useEffect(() => {
    // Default state - disable user list
    const userListContainer = document.getElementById("container_user_list");
    if (userListContainer) {
      userListContainer.classList.add('disabled_dropdown');
    }
   
    getUserList();
    fetchAllRoles();
   
    if(data) {
      const submitBtn = document.getElementById("submitBtn");
      if (submitBtn) {
        submitBtn.style.display = "none";
      }
     
      // Set all other form fields except role_list and user_list
      const formData = {...data};
      delete formData.role_list;
      delete formData.user_list;
     
      reset(formData);
     
      // Toggle appropriate dropdowns based on assign_type in view mode
      if(isTextFieldDisable) {
        toggleDropdownsBasedOnAssignType(data.assign_type);
      }
     
      console.log("Initial data:", data);
    }
  }, []);
 
  // Handle changes to assign_type
  useEffect(() => {
    if (assign_type !== undefined) {
      toggleDropdownsBasedOnAssignType(assign_type);
    }
  }, [assign_type]);
 
  // Handle changes to task_type
  useEffect(() => {
    if (task_type !== undefined) {
      const assignTaskContainer = document.getElementById("assign_task");
     
      if (task_type == 1) {
        if (assignTaskContainer) {
          assignTaskContainer.classList.add("disabled_dropdown");
        }
       
        // Only change assign_task if not in view mode and based on assign_type
        if (!isTextFieldDisable) {
          // If assign_type is 1, set assign_task to empty string
          if (assign_type == 1) {
            setValue("assign_task", "", { shouldValidate: true });
          } else {
            setValue("assign_task", "1", { shouldValidate: true });
          }
        }
      } else if (assign_type == 0) {
        if (assignTaskContainer) {
          assignTaskContainer.classList.remove("disabled_dropdown");
        }
       
        // Don't automatically set assign_task in view mode
        if (!isTextFieldDisable && !getValues("assign_task")) {
          setValue("assign_task", "1", { shouldValidate: true });
        }
      }
    }
  }, [task_type, assign_type]);
 
  // Update the toggle function to properly handle assign_task based on assign_type
  const toggleDropdownsBasedOnAssignType = (type, preserveAssignTask = null) => {
    const userListContainer = document.getElementById("container_user_list");
    const roleListContainer = document.getElementById("container_role_list");
    const assignTaskContainer = document.getElementById("assign_task");
   
    if (type == 1) {
      // User-based assignment
      if (userListContainer) userListContainer.classList.remove('disabled_dropdown');
      if (roleListContainer) roleListContainer.classList.add('disabled_dropdown');
      if (assignTaskContainer) assignTaskContainer.classList.add('disabled_dropdown');
     
      setValue("role_list", [], { shouldValidate: true });
     
      // For user-based assignment (type 1), always set assign_task to empty string
      // regardless of task_type or view mode
      setValue("assign_task", "", { shouldValidate: true });
     
      // Only refresh user list if not in view mode
      if (!isTextFieldDisable) {
        getUserList();
      }
    } else if (type == 0) {
      // Role-based assignment
      if (userListContainer) userListContainer.classList.add('disabled_dropdown');
      if (roleListContainer) roleListContainer.classList.remove('disabled_dropdown');
      if (assignTaskContainer) assignTaskContainer.classList.remove('disabled_dropdown');
     
      setValue("user_list", [], { shouldValidate: true });
     
      // Only override assign_task if not in view mode or preserveAssignTask not provided
      if (!isTextFieldDisable && !preserveAssignTask) {
        setValue("assign_task", "1", { shouldValidate: true });
      } else if (preserveAssignTask) {
        setValue("assign_task", preserveAssignTask, { shouldValidate: true });
      }
    }
  };
 
  const getUserList = async () => {
    setLoader(true);
    try {
      var userIdNameMap = {};
      var userList = await getData(getUsersFromApp);
      (userList).sort((a, b) => (a.name > b.name) ? 1: -1);
      let userArrSanitized = [];
      userList.forEach((user, index) => {
        userIdNameMap[user.id] = user.first_name+" "+user.last_name;
        userArrSanitized.push({
          label: user.first_name+" "+user.last_name,
          value: user.id,
        });
      });
     
      const updatedConfig = [...taskMgntFormConfig];
      updatedConfig[0].fields[5]["options"] = userArrSanitized;
      setTaskMgntFormConfig(updatedConfig);
     
      populateUserList(userIdNameMap);
    } catch (error) {
      console.error("Error fetching user list:", error);
      toast.error("Failed to load user list");
    } finally {
      setLoader(false);
    }
  };
 
  const populateUserList = (userIdNameMap) => {
    if(data && data.user_list && (!isTextFieldDisable || data.assign_type == 1)) {
      // Only populate if not in view mode OR if in the correct assign type
      const userIds = data.user_list.split(",");
     
      const userOptions = userIds.map(id => ({
        label: userIdNameMap[id] || id,
        value: id
      })).filter(option => option.label);
     
      console.log("Setting user_list to:", userOptions);
      setValue("user_list", userOptions, { shouldValidate: true });
    } else if (isTextFieldDisable && data?.assign_type == 0) {
      // Clear user list if in view mode and assign type is role-based
      setValue("user_list", [], { shouldValidate: true });
    }
  };
 
  const populateRoleList = (roleIdNameMap) => {
    if(data && data.role_list) {
      // Parse the comma-separated string into an array of IDs
      const roleIds = data.role_list.split(",");
     
      // Create an array of objects in the format expected by the multi-select component
      const roleOptions = roleIds.map(id => ({
        label: roleIdNameMap[id] || id,
        value: id
      })).filter(option => option.label); // Remove any invalid entries
     
      console.log("Setting role_list to:", roleOptions);
      setValue("role_list", roleOptions, { shouldValidate: true });
    }
  };
 
  const fetchAllRoles = async () => {
    setLoader(true);
    try {
      let rolearr = await getData(getAllRole);
      (rolearr).sort((a, b) => (a.name > b.name) ? 1: -1);
      let roleArrSanitized = [];
      var roleIdNameMap = {};
      rolearr.forEach((role, index) => {
        roleIdNameMap[role.id] = role.name;
        roleArrSanitized.push({
          label: role.name,
          value: role.id,
        });
      });
     
      const updatedConfig = [...taskMgntFormConfig];
      updatedConfig[0].fields[4]["options"] = roleArrSanitized;
      setTaskMgntFormConfig(updatedConfig);
     
      populateRoleList(roleIdNameMap);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles");
    } finally {
      setLoader(false);
    }
  };
 
  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        <FormHandler
          register={register}
          errors={errors}
          fields={fields}
          control={control}
          columns={2}
          getValues={getValues}
          isTextFieldDisable={isTextFieldDisable}
        />
      </div>
    );
  };
 
  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };
 
  const submitHandler = async (data, e) => {
    e.preventDefault(); // Prevent default form submission
    setIsSubmitting(true); // Disable the button immediately
 
    const formData = new FormData();
 
    // Append common fields
    formData.append("email", keycloak.idTokenParsed.email);
 
    // Process and append user_list as a comma-separated string
    if (data.user_list && data.user_list.length > 0) {
      const userList = data.user_list.map((user) => user.value).join(",");
      formData.append("user_list", userList); // Append as a single string
    } else {
      formData.append("user_list", "");
    }
 
    // Process and append role_list as a comma-separated string
    if (data.role_list && data.role_list.length > 0) {
      const roleList = data.role_list.map((role) => role.value).join(",");
      formData.append("role_list", roleList); // Append as a single string
    } else {
      formData.append("role_list", "");
    }
 
    // Add any other data fields
    for (let key in data) {
      if (!["user_list", "role_list"].includes(key)) {
        formData.append(key, data[key]);
      }
    }
 
    setLoader(true); // Show loader
 
    try {
      // Make the API call
      const headers = { "Content-Type": "multipart/form-data" };
      const res = await postDataWithBody(createNewTask, formData, headers);
   
      // Handle response
      if (res.status === "success") {
        toast.success(res.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000, // Close after 2 seconds
        });
        navigate("/my-tasks/view-usertask");
      } else {
        toast.error(res.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000, // Close after 2 seconds
        });
        setIsSubmitting(false); // Re-enable the button on error
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("An error occurred while submitting the form", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      setIsSubmitting(false); // Re-enable the button on error
    } finally {
      setLoader(false); // Hide loader regardless of outcome
    }
  };
 
  const tabsData = generateTabsData(taskMgntFormConfig);
 
  return (
    <div className="mt-4 facility-container">
      <div className="form-body">
        <div className="registration__form--body">
          <form
            onSubmit={handleSubmit(submitHandler)}
            name="CreateFacilityRegForm"
          >
            <div>
              {tabsData?.map((tab) => (
                <React.Fragment key={tab.id}>
                  {tab.id === activeTab && (
                    <>
                      <div>{tab.component}</div>
                    </>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className="d-flex justify-content-center">
              {tabsData.length - 1 === activeTab && (
                <Button
                  type="submit"
                  id="submitBtn"
                  className="mx-2"
                  variant="primary"
                  disabled={isSubmitting} // Disable button when form is submitting
                >
                  {isSubmitting ? 'Submitting...' : 'Save & Submit'}
                </Button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
 
export default CreateUserTaskForm;
 